export const environment = {
  production: false,

  clientName: 'socie_inmo',
  apiGatewayFront: 'https://agpsociedad.unico.com.co/',
  apiGatewayBackOffice: 'https://agpsociedad.unico.com.co/',
  apiUrl: 'https://agpsociedad.unico.com.co/',
  urlPath: 'https://agpsociedad.unico.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LfEV3cqAAAAAPF6rDCGCcGJnL6FLJzvTLcu7CcV',

  googleAnalyticsCode: 'UA-140785247-1',
};